/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import vmodal from 'vue-js-modal';
import { isNumber } from '@/utils/number';
import { forEach, reduce, isEmpty } from 'lodash';

import MapConst from '@/constants/topologymap';

const Q = window.Q;
const MapInfo = (() => { // eslint-disable-line no-shadow
  const _instance = {};
  const Info = () => {
    let _graph = null;
    let _canvas = null;
    let _panel = null;
    let _toolbar = {
      monitoring: null,
      edit: null,
      slideshow: null,
    };
    let _completeCallbackList = [];
    let _clearCallbackList = [];
    let _editHistoryStack = [];
    let _isHighlightElements = false;
    let _automapProcessTask = [];

    return {
      clearInfo() {
        if (_graph) {
          _graph.destroy();
        }
        _graph = null;
        _canvas = null;
        _panel = null;
        _toolbar = {
          monitoring: null,
          edit: null,
          slideshow: null,
        };
        _completeCallbackList = [];
        _clearCallbackList = [];
        _editHistoryStack = [];
        this.clearAutomapProcess();
      },

      setGraph(graph) {
        _graph = graph;
      },
      getGraph() {
        return _graph;
      },

      setCanvas(canvas) {
        _canvas = canvas;
      },
      getCanvas() {
        return _canvas;
      },

      setPanel(panel) {
        _panel = panel;
      },
      getPanel() {
        return _panel;
      },

      setToolbar(viewMode, toolbar) {
        _toolbar[viewMode] = toolbar;
      },
      getToolbar(viewMode) {
        if (_toolbar[viewMode]) {
          return _toolbar[viewMode];
        }
        return _toolbar.monitoring;
      },
      addMapCompleteCallback(func) {
        if (func instanceof Function) {
          _completeCallbackList.push(func);
        }
      },
      callMapCompleteCallback() {
        _completeCallbackList.forEach((func) => {
          setTimeout(() => {
            func.call();
          }, 0);
        });
      },
      addMapClearCallback(func) {
        if (func instanceof Function) {
          _clearCallbackList.push(func);
        }
      },
      callMapClearCallback() {
        _clearCallbackList.forEach((func) => {
          setTimeout(() => {
            func.call();
          }, 0);
        });
      },
      addEditHistory(history) {
        _editHistoryStack.push(history);
      },
      clearEditHistoryStack() {
        _editHistoryStack.length = 0;
      },
      undoEditHook(type, history) {
        if (type === MapConst.HISTORY_TYPE.PROPERTY && history.property === 'lineDirection' && history.element instanceof Q.LanModel) {
          history.element.changeLineDirection();
        }
      },
      undoEditHistory() {
        try {
          const history = _editHistoryStack.pop();

          if (history) {
            switch (history.type) {
              case MapConst.HISTORY_TYPE.ADD:
                history.elements.forEach((item) => {
                  _graph.removeElement(item);
                });
                break;

              case MapConst.HISTORY_TYPE.REPLACE:
                if (history.newElement && history.oldElement) {
                  _graph.addElement(history.oldElement);
                  history.newElement.getEdges().forEach((edge) => {
                    edge.changeAgent(edge.from === history.newElement ? 'SRC' : 'DST', history.oldElement);
                  });
                  _graph.removeElement(history.newElement);
                }
                break;

              case MapConst.HISTORY_TYPE.REMOVE: {
                const nodes = history.elements.filter((element) => element instanceof Q.Node);
                const edges = history.elements.filter((element) => element instanceof Q.Edge);

                nodes.forEach((node) => {
                  _graph.addElement(node);
                });

                edges.forEach((edge) => {
                  const newEdge = new Q.LanModel(edge.get('model'), edge.fromAgent, edge.toAgent);
                  _graph.addElement(newEdge);
                });
                break;
              }

              case MapConst.HISTORY_TYPE.LOCATION:
                history.elements.forEach((item) => {
                  item.element.x = item.x;
                  item.element.y = item.y;
                });
                break;

              case MapConst.HISTORY_TYPE.SIZE:
                history.elements.forEach((item) => {
                  item.element.size = {
                    width: item.width,
                    height: item.height,
                  };
                  item.element.x = item.x;
                  item.element.y = item.y;
                });
                break;

              case MapConst.HISTORY_TYPE.ALIGN:
                history.elements.forEach((item) => {
                  item.element.x = item.x;
                  item.element.y = item.y;
                  item.element.zIndex = item.z;
                });
                break;

              case MapConst.HISTORY_TYPE.PROPERTY:
                history.elements.forEach((item) => {
                  this.undoEditHook(history.type, item);

                  item.element.set(item.property, item.value);
                });
                break;

              default:
            }
          }
        } catch (e) {
          Q.log(e);
        }
      },
      mask(text) {
        try {
          this.getPanel().loadingText = text;
          this.getPanel().loading = true;
        } catch (e) {
          // ignore
        }
      },
      unmask() {
        try {
          this.getPanel().loading = false;
          this.getPanel().loadingText = '';
        } catch (e) {
          // ignore
        }
      },
      exportImage(callback) {
        const graph = this.getGraph();
        const background = graph.background;
        const grid = background.canvas;
        const image = background.imageCanvas;
        let bounds;

        if (graph.scale < 1) {
          bounds = new Q.Rect(graph.viewportBounds.x, graph.viewportBounds.y, graph.viewportBounds.width, graph.viewportBounds.height);
        } else {
          bounds = new Q.Rect(graph.viewportBounds.x, graph.viewportBounds.y, graph.width / graph.scale, graph.height / graph.scale);
        }
        const content = graph.exportImage(graph.scale, bounds);

        const gridImgEl = new Image();
        const imageImgEl = new Image();
        const contentImgEl = new Image();
        const errorFunc = () => {
          if (callback) {
            callback.call();
          }
        };

        const graphArea = this.getCanvas().$refs.graphArea.$el;
        let exportCanvas = document.getElementById('exportImageCanvas');
        if (exportCanvas) {
          graphArea.removeChild(exportCanvas);
        }

        exportCanvas = document.createElement('canvas');
        exportCanvas.setAttribute('id', 'exportImageCanvas');
        exportCanvas.setAttribute('width', graph.width);
        exportCanvas.setAttribute('height', graph.height);
        exportCanvas.setAttribute('style', 'position:absolute;top:0;left:0;display:none;');
        graphArea.appendChild(exportCanvas);

        imageImgEl.onerror = errorFunc;
        gridImgEl.onerror = errorFunc;
        contentImgEl.onerror = errorFunc;

        imageImgEl.src = image.toDataURL();
        imageImgEl.onload = () => {
          exportCanvas.getContext('2d').drawImage(imageImgEl, 0, 0);
          gridImgEl.src = grid.toDataURL();
        };
        gridImgEl.onload = () => {
          if (graph.topologymapModel.gridShowFlag === '1') {
            exportCanvas.getContext('2d').drawImage(gridImgEl, 0, 0);
          }
          contentImgEl.src = content.data;
        };
        contentImgEl.onload = () => {
          exportCanvas.getContext('2d').drawImage(contentImgEl, 0, 0);

          // 테스트
          // var win = window.open();
          // win.document.write("<img src='"+exportCanvas[0].toDataURL('image/png')+"'/>");

          if (callback) {
            callback(exportCanvas.toDataURL('image/png'));
          }

          graphArea.removeChild(exportCanvas);
        };
      },
      /**
       * 정렬 대상이 되는 오브젝트를 반환한다.
       * 즉, 선을 제외한 오브젝트가 대상이다.
       * @return {[type]} [description]
       */
      getAlignTargetModel() {
        const graph = this.getGraph();
        const sm = graph.selectionModel.toDatas();
        let targetModels = [];
        const historyElements = [];

        targetModels = sm.filter((model) => {
          const result = !(model instanceof Q.LanModel) && !(model instanceof Q.VirtualLanModel);

          if (result) {
            historyElements.push({
              element: model,
              x: model.x,
              y: model.y,
              z: model.zIndex,
            });
          }
          return result;
        });

        this.addEditHistory({
          type: MapConst.HISTORY_TYPE.ALIGN,
          elements: historyElements,
        });

        return targetModels;
      },
      isViewPin() {
        let result = false;
        try {
          const topologymapModel = this.getGraph().topologymapModel;
          if (topologymapModel && (!!topologymapModel.x && !!topologymapModel.y && !!topologymapModel.mapScale)) {
            result = true;
          }
          return result;
        } catch (exception) {
          return false;
        }
      },
      highlightElements(elements) {
        if (elements) {
          const mapElement = this.elementArrToMap(elements);
          this.getGraph().graphModel.forEach((element) => {
            if (mapElement[element.id]) {
              element.setStyle(Q.Styles.ALPHA, 1);
            } else {
              element.setStyle(Q.Styles.ALPHA, 0.1);
            }
          });
          _isHighlightElements = true;
        } else {
          this.unhighlightElements();
        }
      },
      unhighlightElements() {
        if (_isHighlightElements) {
          this.getGraph().graphModel.forEach((element) => {
            element.setStyle(Q.Styles.ALPHA, 1);
          });
        }

        _isHighlightElements = false;
      },
      elementArrToMap(elements) {
        return reduce(elements, (result, element) => {
          result[element.id] = element;
          return result;
        }, {});
      },
      addAutomapProcess(process) {
        _automapProcessTask.push(process);
      },
      clearAutomapProcess() {
        _automapProcessTask.forEach((process) => {
          if (process) {
            process.complete();
          }
        });
        _automapProcessTask = [];
      },
    };
  };
  return {
    removeInstance(param) {
      const id = this.getInstanceId(param);

      const inst = _instance[id];
      if (inst) {
        inst.clearInfo();
      }
      _instance[id] = null;
      delete _instance[id];
    },
    setInstance(param) {
      const id = this.getInstanceId(param);

      let inst = _instance[id];
      if (!inst) {
        inst = new Info();
        _instance[id] = inst;
      }
    },
    getInstance(param) {
      const id = this.getInstanceId(param);

      return _instance[id];
    },
    getInstanceId(param) {
      let id;

      if (param instanceof Vue) { // Vue instance로 찾을 때
        id = param.$root._uid;
      } else if (param instanceof Q.BaseModel) { // Graph Model로 찾을 때
        forEach(_instance, (value, key) => {
          const el = value.getGraph().getElement(param.id);
          if (el && (el === param)) {
            id = key;
            return false;
          }
          return true;
        });
      } else if (param instanceof Q.Graph) { // Graph로 찾을 때
        forEach(_instance, (value, key) => {
          if (param === value.getGraph()) {
            id = key;
            return false;
          }
          return true;
        });
      }

      // 찾아지는 instance가 없으면 기본으로 첫번째 instanceId 반환
      if (!id) {
        id = Object.keys(_instance)[0];
      }
      return id;
    },
  };
})();

const MapUtil = {
  isFullScreen() {
    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      return false;
    }
    return true;
  },
  trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
  },
  rgbaToHex(rgba) {
    try {
      const parts = rgba.substring(rgba.indexOf('(')).split(',');
      const r = parseInt(this.trim(parts[0].substring(1)), 10);
      const g = parseInt(this.trim(parts[1]), 10);
      const b = parseInt(this.trim(parts[2]), 10);
      const a = parseFloat(this.trim(parts[3].substring(0, parts[3].length - 1))).toFixed(2);

      return `#${this.lpad(r.toString(16), 2)}${this.lpad(g.toString(16), 2)}${this.lpad(b.toString(16), 2)}${this.lpad((a * 255).toString(16).substring(0, 2), 2)}`;
    } catch (e) {
      return '#ffffffff';
    }
  },
  /**
   * Hex를 Rgba로 변환한다.
   * @param  {[type]} hex   [description]
   * @param  {[type]} alpha [description]
   * @return {[type]}       [description]
   */
  hexToRgbA(hex, alpha) {
    try {
      const re = new RegExp('#([A-Fa-f0-9]{3}){1,2}');

      if (re.test(hex)) {
        let c = hex.substring(1).split('');
        const length = c.length;

        if (length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }

        c = `0x${c.join('')}`;

        let r;
        let g;
        let b;
        let a;

        /* eslint-disable no-bitwise, no-void */
        if (length === 3 || length === 6) {
          r = (c >> 16) & 255;
          g = (c >> 8) & 255;
          b = c & 255;
          a = parseFloat(alpha !== void 0 ? alpha : 1).toFixed(2);

          return `rgba(${[r, g, b, a].join(',')})`;
        } else if (length === 8) {
          r = (c >> 24) & 255;
          g = (c >> 16) & 255;
          b = (c >> 8) & 255;
          a = parseFloat(alpha !== void 0 ? alpha : 1 || (c & 255) / 255).toFixed(2);

          return `rgba(${[r, g, b, a].join(',')})`;
        }
        /* eslint-enable no-bitwise, no-void */
      }
      throw new Error('Bad Hex');
    } catch (e) {
      // Q.log(e);
      return 'rgba(0,0,0,1)';
    }
  },
  /**
   * Hex에서 Alpha값을 추출한다.
   * @param  {[type]} hex [description]
   * @return {[type]}     [description]
   */
  hex8ToAlpha(hex) {
    try {
      const re = new RegExp('#([A-Fa-f0-9]{3}){1,2}');

      if (re.test(hex)) {
        let c = hex.substring(1).split('');
        const length = c.length;

        /* eslint-disable no-bitwise */
        if (length === 8) {
          c = `0x${c.join('')}`;
          return ((c & 255) / 255).toFixed(2);
        }
        /* eslint-enable no-bitwise */
      }
      throw new Error('Bad Hex');
    } catch (e) {
      // Q.log(e);
      return 1;
    }
  },
  /**
   * Alpha값을 Hex로 변환한다.
   * @param  {[type]} alpha [description]
   * @return {[type]}       [description]
   */
  alphaToHex(alpha) {
    try {
      /* eslint-disable no-bitwise */
      if (alpha >= 0 && alpha <= 1) {
        let hex = ((alpha * 255) & 255).toString(16);
        hex = hex === '0' ? '00' : hex;
        return hex;
      }
      /* eslint-enable no-bitwise */
      throw new Error('Bad Alpha');
    } catch (e) {
      // Q.log(e);
      return 'ff';
    }
  },
  /**
   * Hex6를 Hex8 형태로 변환한다.
   * @param  {[type]} hex   [description]
   * @param  {[type]} alpha [description]
   * @return {[type]}       [description]
   */
  hex6ToHex8(hex, alpha) {
    try {
      const re = new RegExp('#([A-Fa-f0-9]{3}){1,2}');
      if (re.test(hex)) {
        const c = hex.substring(1).split('');
        const length = c.length;

        if (length === 6) {
          return `#${[c[0], c[1], c[2], c[3], c[4], c[5]].join('')}${this.alphaToHex(alpha)}`;
        }
      }
      throw new Error('Bad Hex');
    } catch (e) {
      // Q.log(e);
      return '#ffffffff';
    }
  },
  /**
   * Hex8을 Hex6 형태로 변환한다.
   * @param  {[type]} hex [description]
   * @return {[type]}     [description]
   */
  hex8ToHex6(hex) {
    try {
      const re = new RegExp('#([A-Fa-f0-9]{3}){1,2}');

      if (re.test(hex)) {
        const c = hex.substring(1).split('');
        const length = c.length;

        if (length === 8) {
          return `#${[c[0], c[1], c[2], c[3], c[4], c[5]].join('')}`;
        }
      }
      throw new Error('Bad Hex');
    } catch (e) {
      // Q.log(e);
      return '#ffffff';
    }
  },
  lpad(n, width) {
    const s = `${n}`;
    return s.length >= width ? s : new Array((width - s.length) + 1).join('0') + s;
  },
  enumerables: ['valueOf', 'toLocaleString', 'toString', 'constructor'],
  clone(item) {
    /* eslint-disable */
    // jshint ignore: start
    if (item === null || item === undefined) {
      return item;
    }

    if (item.nodeType && item.cloneNode) {
      return item.cloneNode(true);
    }

    //@description IE에서 붙여넣기가 안되던 오류 해결. 공식 API에서 권장하는 방법 사용
    //@author: JungGueSeon	@since: 2018-07-12 17:34:51
    var toString = Object.prototype.toString;
    var type = toString.call(item),
      i,
      j,
      k,
      clone,
      key;

    if (type === '[object Date]') {
      return new Date(item.getTime());
    }

    if (type === '[object Array]') {
      i = item.length;
      clone = [];
      while (i--) {
        clone[i] = this.clone(item[i]);
      }
    } else if (type === '[object Object]' && item.constructor === Object) {
      clone = {};
      for (key in item) {
        clone[key] = this.clone(item[key]);
      }
      if (this.enumerables) {
        for (j = this.enumerables.length; j--; ) {
          k = this.enumerables[j];
          if (item.hasOwnProperty(k)) {
            clone[k] = item[k];
          }
        }
      }
    }
    return clone || item;
    // jshint ignore:end
    /* eslint-enable */
  },
  changeUnitWithoutB(a, b, c, isTrim) {
    let value = a;
    let decimalPoint = b;
    const unit = c;

    if (decimalPoint === null || decimalPoint === undefined) {
      decimalPoint = 2;
    }

    if (unit === '' || unit === '%' || unit === 'count' || unit === 'ms' || unit === 'count/sec') {
      if (typeof value !== 'number') {
        value = parseFloat(value);
        if (isNaN(value)) {
          value = 0;
        }
      }
      return value.toFixed(decimalPoint);
    }
    let minusFlag = 1;

    // 단위변환 값, 소수점 자리 지정
    let bytes = value;

    if (bytes < 0) {
      minusFlag = -1;
      bytes *= minusFlag;
    }

    // 단위
    const units = [' ', 'K', 'M', 'G', 'T', 'P'];

    // 단위변환 값 예외처리
    if (typeof bytes !== 'number') {
      bytes = parseFloat(bytes);
      if (isNaN(bytes)) {
        bytes = 0;
      }
    }

    if (bytes === 0) {
      if (isTrim) {
        return 0;
      }
      return 0 + units[0];
    }

    // 값에 맞는 단위 index 구함.
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)), 10);
    if (i < 0) {
      return Number(value).toFixed(decimalPoint) + units[0];
    } else if (i >= units.length) {
      i = units.length - 1;
    }

    value = (bytes / Math.pow(1000, i)).toFixed(decimalPoint); // eslint-disable-line no-restricted-properties
    value *= minusFlag;
    if (isTrim) {
      value = `${value}${units[i]}`;
    } else {
      value = `${value} ${units[i]}`;
    }
    return value;
  },
  pngImage: [
    'ACCELELATOR',
    'AGENT',
    'ALTIBASE',
    'AP_CONTROLLER',
    'ATMGSW',
    'ATMGSW1',
    'ATMROUTER',
    'ATMSW',
    'AUTHSERVER',
    'BACKBONESWITCH',
    'BACKUP',
    'BRIDGE',
    'CDDI',
    'COMM',
    'COMPAQ',
    'COREROUTER',
    'CSU',
    'CUBRID',
    'DATABASE',
    'DATACENTER',
    'DB2',
    'DB_NM',
    'DDOS',
    'DHCP',
    'DNS',
    'DSU',
    'ETC',
    'FACILITY',
    'FADC',
    'FAIRFLOW',
    'FCAM',
    'FCAML',
    'FCAMR',
    'FCM',
    'FFIREDS',
    'FFIREDSL',
    'FFIREDSR',
    'FGCU',
    'FIREWALL',
    'FNSDS',
    'FPDUS',
    'FREEBSD',
    'FRT',
    'FSENSOR',
    'FSENSORL',
    'FSENSORR',
    'FTEMP',
    'FTH',
    'FTHEHYGRO',
    'FTHEYGROL',
    'FTHEYGROR',
    'FTHL',
    'FTHR',
    'FUPS',
    'FUPSL',
    'FUPSR',
    'FVA',
    'FVSBMS',
    'FWLDS',
    'FWLDSL',
    'FWLDSR',
    'GATEWAY',
    'GROUP',
    'GRP',
    'HPUX',
    'HUB',
    'IBMAIX',
    'IDS',
    'IDSNSW',
    'IF',
    'IF_LOOPBACK',
    'IF_LOOPBACK_X',
    'IF_OTHER',
    'IF_OTHER_X',
    'IF_X',
    'INFORMIX',
    'IPS',
    'IPT',
    'JBOSS',
    'JEUS',
    'L2SW',
    'L3SW',
    'L4SW',
    'LDC',
    'LINUX',
    'LOCATION',
    'MAC_GROUP',
    'MSSQL',
    'MYSQL',
    'NAS',
    'NETWORK',
    'NULL',
    'OAS',
    'ORACLE',
    'PCLINUX',
    'PCMAC',
    'PCWIN',
    'POSTGRE',
    'POSTGRESQL',
    'PRINTER',
    'PROBE',
    'PTP',
    'ROUTER',
    'RTU',
    'SAN',
    'SC',
    'SCRIPT',
    'SERVICE',
    'SGIIRIX',
    'SOLARIS',
    'SS',
    'STORAGE',
    'SYBASE',
    'SYBASEIQ',
    'TIBERO',
    'TOMCAT',
    'TRANSACTION',
    'UK',
    'UNIXWARE',
    'VCL',
    'VDC',
    'VDS',
    'VDSC',
    'VFO',
    'VHO',
    'VIRTUAL',
    'VIRTUALSVR',
    'VLAN',
    'VNW',
    'VOIP',
    'VPN',
    'VTM',
    'VVC',
    'VVM',
    'WAS',
    'WEBLOGIC',
    'WEBSPHERE',
    'WINSVR',
    'WIRELESSAP',
    'XDSL',
    'XT',
  ].reduce((result, value) => {
    result[value] = value;
    return result;
  }, {}),
  hasPngImage(imageName) {
    return Object.prototype.hasOwnProperty.call(this.pngImage, imageName);
  },
  /**
   * 인터페이스(회선)명 반환. 현재 우선순위 (alias -> name -> desc)
   * @author KangBongHun(toto1323)
   * @param  {[type]} alias    [description]
   * @param  {[type]} name     [description]
   * @param  {[type]} desc     [description]
   * @param  {[type]} specific [description]
   * @return {[type]}          [description]
   */
  getInterfaceLabel(alias, name, desc, specific) {
    const labels = { alias, name, desc };
    let result;

    // 지정한 라벨
    if (!isEmpty(specific)) {
      result = labels[specific];
    }

    // 지정한 라벨이 없다면 우선순위대로
    if (isEmpty(result)) {
      forEach(labels, (value, key) => {
        if (value) {
          result = value;
          return false;
        }
        return true;
      });
    }

    return result;
  },
};

const MapPopup = {
  /**
   * 팝업을 나타낸다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} popup       팝업 컴포넌트
   * @param  {Object} [params={}] 팝업에 전달 할 데이터
   * @param  {Object} [config={}] 팝업 속성
   * @param  {Object} [events={}] 콜백 함수
   * @return {[type]}             [description]
   */
  showPopup(popup, param = {}) {
    const data = param.data || {};
    const config = param.config || {};
    const events = param.events || {};

    const popupContainer = vmodal.dynamicContainer;
    const p = Object.assign(popup.data().params || {}, data);
    const c = Object.assign(popup.data().config || {}, { name: popup.name }, config);
    const e = popup.data().events || {};

    const baseEvents = {
      'before-open': (evt) => {
        evt.data = p;
        evt.popup = this.getPopup(popup.name).popup;

        this.beforeOpen(evt);

        if (e.beforeOpen) {
          e.beforeOpen(evt);
        }
        if (events.beforeOpen) {
          events.beforeOpen(evt);
        }
      },
      opened: (evt) => {
        evt.data = p;
        evt.popup = this.getPopup(popup.name).popup;

        this.opened(evt);

        if (e.opened) {
          e.opened(evt);
        }
        if (events.opened) {
          events.opened(evt);
        }

        this.shown(evt);

        if (e.shown) {
          e.shown(evt);
        }
        if (events.shown) {
          events.shown(evt);
        }
      },
      'before-close': (evt) => {
        evt.data = p;
        evt.popup = this.getPopup(popup.name).popup;

        this.beforeClose(evt);

        if (e.beforeClose) {
          e.beforeClose(evt);
        }
        if (events.beforeClose) {
          events.beforeClose(evt);
        }
      },
      closed: (evt) => {
        evt.data = p;
        evt.popup = this.getPopup(popup.name).popup;

        this.closed(evt);

        if (e.closed) {
          e.closed(evt);
        }
        if (events.closed) {
          events.closed(evt);
        }
      },
      hidden: (evt) => {
        evt.data = p;
        evt.popup = this.getPopup(popup.name).popup;

        this.hidden(evt);

        if (e.hidden) {
          e.hidden(evt);
        }
        if (events.hidden) {
          events.hidden(evt);
        }
      },
      shown: (evt) => {
        evt.data = p;
        evt.popup = this.getPopup(popup.name).popup;

        this.shown(evt);

        if (e.shown) {
          e.shown(evt);
        }
        if (events.shown) {
          events.shown(evt);
        }
      },
    };

    const existedPopup = this.getPopup(popup.name).wrapper;
    if (existedPopup) {
      const existedPopupData = vmodal.dynamicContainer.modals.find((item) => item.config.name === popup.name);
      existedPopupData.params = p;
      existedPopupData.config = c;
      existedPopupData.events = baseEvents;
      popupContainer.$nextTick(() => {
        existedPopup.$el.style.visibility = 'visible';
        existedPopup.$emit('shown', existedPopup.genEventObject());
      });
    } else {
      if (c.type === MapConst.POPUP_TYPE.WINDOW) {
        const pivotXY = this.getPivotXY(isNumber(c.width) ? c.width : 400, isNumber(c.height) ? c.height : 100, c.x, c.y);
        c.pivotX = pivotXY.pivotX;
        c.pivotY = pivotXY.pivotY;
      } else {
        c.pivotX = 0.5;
        c.pivotY = 0.5;
      }
      popupContainer.$modal.show(popup, p, c, baseEvents);
    }
  },
  beforeOpen() {},
  opened(evt) {
    this.reorderIndex(evt.name);
  },
  beforeClose() {},
  closed() {},
  hidden() {},
  shown() {},
  /**
   * [getPivotXY popup 좌표값에 따라 상대 수치 반환]
   * @author ryunnnne
   * @param  {[Number]} width  [팝업 너비]
   * @param  {[Number]} height [팝업 높이]
   * @param  {[Number]} x      [팝업 x좌표]
   * @param  {[Number]} y      [팝업 y좌표]
   * @return {[Object]}        [팝업 상대 x,y 수치]
   */
  getPivotXY(width, height, x, y) {
    // const panelEl = MapInfo.getPanel().$el;
    const gx = 0; // window.innerWidth - panelEl.clientWidth;
    const gy = 0; // window.innerHeight - panelEl.clientHeight;
    const w = window.innerWidth - width;
    const h = window.innerHeight - height;

    let pivotX = (gx + x) / w;
    let pivotY = (gy + y) / h;

    if (pivotX > 1) {
      pivotX = 1;
    }
    if (pivotX < 0) {
      pivotX = 0;
    }

    if (pivotY > 1) {
      pivotY = 1;
    }
    if (pivotY < 0) {
      pivotY = 0;
    }

    return {
      pivotX: !isNaN(pivotX) ? pivotX : 0.5,
      pivotY: !isNaN(pivotY) ? pivotY : 0.5,
    };
  },
  /**
   * 팝업을 반환한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} name 팝업 이름
   * @return {[type]}      팝업 객체
   */
  getPopup(name) {
    const popupContainer = vmodal.dynamicContainer;
    const popup = popupContainer.$children.find((item) => item.name === name);
    return {
      wrapper: popup,
      popup: popup && popup.$children[0],
    };
  },
  getPopupByEvent(evt) {
    return this.getPopup(evt.name);
  },
  /**
   * 팝업 z-index를 재정렬한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */
  reorderIndex(name) {
    const popup = this.getPopup(name).wrapper;

    if (popup.$attrs.type === MapConst.POPUP_TYPE.WINDOW) {
      const popupContainer = vmodal.dynamicContainer;
      const popups = popupContainer.$children;
      let maxIndex = 0;
      if (popups.length > 1) {
        popups.forEach((p) => {
          const pEl = p.$el;
          if (p.name !== popup.name && Number(pEl.style.zIndex) > maxIndex) {
            maxIndex = Number(pEl.style.zIndex);
          }
        });
        popup.$el.style.zIndex = maxIndex + 1;
      } else {
        popup.$el.style.zIndex = 500;
      }
    } else {
      popup.$el.style.zIndex = 600;
    }
  },
  /**
   * 팝업을 숨기거나 제거한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]}  name    팝업 name
   * @param  {Boolean} isClose 제거여부 true=제거, false=숨김
   * @return {[type]}          [description]
   */
  closeAndHide(name, isClose) {
    let close = true;
    const popup = this.getPopup(name).wrapper;

    if (typeof isClose === 'boolean') {
      close = isClose;
    } else if (popup && popup.$attrs.type === MapConst.POPUP_TYPE.WINDOW) {
      close = false;
    } else {
      close = true;
    }

    if (close) {
      vmodal.dynamicContainer.$modal.hide(name);
    } else {
      popup.$el.style.visibility = 'hidden';
      popup.$emit('hidden', popup.genEventObject());
    }
  },
  /**
   * 모든 팝업을 숨기거나 제거한다.
   * @author KangBonghun(toto1323)
   * @param  {Boolean} isClose 제거여부 true=제거, false=숨김, 그외=모달팝업:제거, 윈도우팝업:숨김
   * @return {[type]}          [description]
   */
  closeAndHideAll(isClose) {
    const popupContainer = vmodal.dynamicContainer;
    const modals = popupContainer.$children;
    modals.forEach((modal) => {
      this.closeAndHide(modal.name, isClose);
    });
  },
};

window.MapInfo = MapInfo;
export default Q;
export { Q, MapInfo, MapUtil, MapPopup };
/* eslint-enable no-underscore-dangle */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/maps.js